/* Progressive enhancement only: no network writes, entry recording or commerce. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-dream-choice]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const controls = section.querySelector('.th-dream-choice-controls');
      const buttons = [...section.querySelectorAll('[data-choice]')];
      const panels = [...section.querySelectorAll('[data-choice-panel]')];
      function select(value) {
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.choice === value)));
        panels.forEach(p => { p.hidden = p.dataset.choicePanel !== value; });
      }
      controls.hidden = false;
      buttons.forEach(b => b.addEventListener('click', () => select(b.dataset.choice)));
      select('experience');
    });
    root.querySelectorAll('[data-dream-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const video = hero.querySelector('[data-dream-background]');
      const button = hero.querySelector('[data-dream-motion]');
      const watch = hero.querySelector('[data-dream-tilt]');
      let userPaused = false;
      let onScreen = true;
      let frame = 0;
      function sync() {
        const paused = !video || video.paused;
        if (button) {
          button.textContent = paused ? 'Play atmosphere ▷' : 'Pause atmosphere Ⅱ';
          button.setAttribute('aria-label', paused ? 'Play campaign atmosphere' : 'Pause campaign atmosphere');
        }
        hero.classList.toggle('th-dream-motion-paused', paused);
      }
      function playback() {
        if (!video) return;
        if (userPaused || reduced.matches || document.hidden || !onScreen || navigator.connection?.saveData) video.pause();
        else { video.muted = true; video.play().catch(sync); }
        sync();
      }
      if (video) {
        if (button) button.hidden = false;
        video.addEventListener('playing', () => hero.classList.add('th-dream-video-ready'));
        video.addEventListener('error', () => hero.classList.remove('th-dream-video-ready'));
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        button?.addEventListener('click', () => {
          if (video.paused) { userPaused = false; video.muted = true; video.play().catch(sync); }
          else { userPaused = true; video.pause(); }
        });
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => { onScreen = entries[0].isIntersecting; playback(); }, { threshold: 0.05 });
          observer.observe(hero);
          hero._dreamObserver = observer;
        }
        document.addEventListener('visibilitychange', playback);
        reduced.addEventListener('change', playback);
        playback();
      }
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        hero.addEventListener('pointermove', event => {
          if (reduced.matches || userPaused || frame) return;
          frame = requestAnimationFrame(() => {
            const rect = hero.getBoundingClientRect();
            watch.style.setProperty('--dream-x', ((event.clientX - rect.left) / rect.width - .5) * 12 + 'px');
            watch.style.setProperty('--dream-y', ((event.clientY - rect.top) / rect.height - .5) * 10 + 'px');
            frame = 0;
          });
        });
        hero.addEventListener('pointerleave', () => { watch.style.setProperty('--dream-x', '0px'); watch.style.setProperty('--dream-y', '0px'); });
      }
    });
    if ('IntersectionObserver' in window && !reduced.matches) {
      const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); }
      }), { threshold: .08, rootMargin: '0px 0px -20px 0px' });
      root.querySelectorAll('[data-dream-reveal]:not(.th-dream-reveal-ready)').forEach(el => { el.classList.add('th-dream-reveal-ready'); reveal.observe(el); });
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-dream-hero]').forEach(h => h._dreamObserver?.disconnect()));
})();
